import api from "../../../utilidades/interceptor";

const urlApi = process.env.REACT_APP_API_KEY

export const getUnits = async () => {
    try {
        const result = await api.get(`${urlApi}/maintenance/getUnitsService`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}

export const getServiceTypes = async () => {
    try {
        const result = await api.get(`${urlApi}/maintenance/getTypeService`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}

export const getProvider = async () => {
    try {
        const result = await api.get(`${urlApi}/maintenance/getProvider`);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}

export const getExistingLogbook = async (data) => {
    try {
        const result = await api.get(`${urlApi}/maintenance/getExistingLogbook?start=${data.horaEntrada}&end=${data.horaSalida}&operador=${data.operador}`);
        return result.data;

    } catch (error) {
        console.log("error", error);
        throw new Error(`Error ${error}`);
    }
}

export const addMaintenanceLog = async (data) => {
    try {
        const result = await api.post(`${urlApi}/maintenance/addMaintenanceLog`, data);
        return result.data;

    } catch (error) {
        console.log("error", error);
        throw new Error(`Error ${error}`);
    }
}

export const getMaintenanceLogs = async (date) => {
    const start = `${date.start.value.toISOString().split('T')[0]} 00:00:00`;
    const end = `${date.end.value.toISOString().split('T')[0]} 23:59:59`;
    try {
        const result = await api.get(`${urlApi}/maintenance/getMaintenanceLogs?start=${start}&end=${end}`);
        return result.data;

    } catch (error) {
        console.log("error", error);
        throw new Error(`Error ${error}`);
    }
}

export const cancelMaintenanceLog = async (id, user) => {
    try {
        const result = await api.post(`${urlApi}/maintenance/cancelMaintenanceLog?id=${id}`, {user});
        return result.data;

    } catch (error) {
        console.log("error", error);
        throw new Error(`Error ${error}`);
    }
}

export const updateMaintenanceLog = async (data) => {
    try {
        const result = await api.post(`${urlApi}/maintenance/updateMaintenanceLog`, data);
        return result.data;

    } catch (error) {
        console.log("error", error);
        throw new Error(`Error ${error}`);
    }
}

export const getTrazo = async (id_bitacora,setTrazoData) => {
    try {
        const result = await api.post(`${urlApi}/maintenance/getTrazoWialon`, { id_bitacora });
        setTrazoData(result.data);
    } catch (error) {
        console.log("error", error);
        throw new Error(`Error ${error}`);
    }
}

export const verificar = async (id, horaInicio, horaFin, pagoChofer) => {
    try {
        const result = await api.post(`${urlApi}/maintenance/${id}/verify`, {
            horaInicio,
            horaFin,
            pagoChofer
        });
        return result.data;
    } catch (error) {
        console.log("error", error);
        throw new Error(`Error ${error}`);
    }
}

